import { render, staticRenderFns } from "./disciplinary-actions-filters.vue?vue&type=template&id=75be70a7&scoped=true"
import script from "./disciplinary-actions-filters.vue?vue&type=script&lang=js"
export * from "./disciplinary-actions-filters.vue?vue&type=script&lang=js"
import style0 from "./disciplinary-actions-filters.vue?vue&type=style&index=0&id=75be70a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be70a7",
  null
  
)

export default component.exports